// ============================================
// ENUMS
// ============================================
export var ClassName;
(function (ClassName) {
    ClassName["Warrior"] = "warrior";
    ClassName["Paladin"] = "paladin";
    ClassName["Rogue"] = "rogue";
    ClassName["Shaman"] = "shaman";
    ClassName["Mage"] = "mage";
    ClassName["Warlock"] = "warlock";
})(ClassName || (ClassName = {}));
export var EquipSlot;
(function (EquipSlot) {
    EquipSlot["Head"] = "head";
    EquipSlot["Chest"] = "chest";
    EquipSlot["Legs"] = "legs";
    EquipSlot["Feet"] = "feet";
    EquipSlot["Hands"] = "hands";
    EquipSlot["Weapon"] = "weapon";
    EquipSlot["Ring"] = "ring";
    EquipSlot["Trinket"] = "trinket";
})(EquipSlot || (EquipSlot = {}));
export var Rarity;
(function (Rarity) {
    Rarity["Common"] = "common";
    Rarity["Uncommon"] = "uncommon";
    Rarity["Rare"] = "rare";
    Rarity["Epic"] = "epic";
    Rarity["Legendary"] = "legendary";
})(Rarity || (Rarity = {}));
export var EnemyType;
(function (EnemyType) {
    EnemyType["Melee"] = "melee";
    EnemyType["Ranged"] = "ranged";
    EnemyType["Caster"] = "caster";
})(EnemyType || (EnemyType = {}));
export var AbilityType;
(function (AbilityType) {
    AbilityType["Damage"] = "damage";
    AbilityType["Heal"] = "heal";
    AbilityType["Buff"] = "buff";
    AbilityType["Debuff"] = "debuff";
    AbilityType["Summon"] = "summon";
    AbilityType["Utility"] = "utility";
})(AbilityType || (AbilityType = {}));
export var SetType;
(function (SetType) {
    SetType["Caster"] = "caster";
    SetType["MeleeDPS"] = "melee_dps";
    SetType["Tank"] = "tank";
})(SetType || (SetType = {}));
export var TargetType;
(function (TargetType) {
    TargetType["Self"] = "self";
    TargetType["Enemy"] = "enemy";
    TargetType["Ally"] = "ally";
    TargetType["AoE"] = "aoe";
    TargetType["Ground"] = "ground";
})(TargetType || (TargetType = {}));
// Boss phase types for visual feedback
export var BossPhaseType;
(function (BossPhaseType) {
    BossPhaseType["Enrage"] = "enrage";
    BossPhaseType["Summon"] = "summon";
    BossPhaseType["Shield"] = "shield";
    BossPhaseType["Regenerate"] = "regenerate";
    BossPhaseType["Frenzy"] = "frenzy"; // Multiple effects combined
})(BossPhaseType || (BossPhaseType = {}));
// ============================================
// FLOOR THEMES
// ============================================
export var FloorTheme;
(function (FloorTheme) {
    FloorTheme["Crypt"] = "crypt";
    FloorTheme["Inferno"] = "inferno";
    FloorTheme["Frozen"] = "frozen";
    FloorTheme["Swamp"] = "swamp";
    FloorTheme["Shadow"] = "shadow";
    FloorTheme["Treasure"] = "treasure"; // Lots of traps, guaranteed rare loot
})(FloorTheme || (FloorTheme = {}));
// ============================================
// CONSUMABLES
// ============================================
export var PotionType;
(function (PotionType) {
    PotionType["Health"] = "health";
    PotionType["Mana"] = "mana";
})(PotionType || (PotionType = {}));
// ============================================
// TRAPS AND CHESTS
// ============================================
export var TrapType;
(function (TrapType) {
    TrapType["Spikes"] = "spikes";
    TrapType["Flamethrower"] = "flamethrower";
})(TrapType || (TrapType = {}));
// ============================================
// GROUND EFFECTS (Boss AoE Spells)
// ============================================
export var GroundEffectType;
(function (GroundEffectType) {
    GroundEffectType["ExpandingCircle"] = "expanding_circle";
    GroundEffectType["FirePool"] = "fire_pool";
    GroundEffectType["MovingWave"] = "moving_wave";
    GroundEffectType["RotatingBeam"] = "rotating_beam";
    GroundEffectType["VoidZone"] = "void_zone";
    GroundEffectType["GravityWell"] = "gravity_well"; // Pulls players toward center - stay at edges!
})(GroundEffectType || (GroundEffectType = {}));
/**
 * Creates a fresh RunTracking object with empty Maps.
 * Called when creating a new run.
 */
export function createRunTracking() {
    return {
        attackCooldowns: new Map(),
        bossAbilityCooldowns: new Map(),
        bossAoECooldowns: new Map(),
        eliteAttackCooldowns: new Map(),
        groundEffectDamageTicks: new Map(),
        playerMovement: new Map(),
        playerMomentum: new Map(),
        bossFightStartTimes: new Map(),
        enemyAggroTimes: new Map(),
        enemyLeashTimers: new Map(),
        playerDeathTimes: new Map(),
        enemyCharging: new Map(),
        enemyChargeCooldowns: new Map(),
        ambushTriggered: new Set(),
        modifierDamageTicks: new Map(),
        bossPhaseTriggered: new Set(),
    };
}
// ============================================
// CRYPTO SYSTEM
// ============================================
export var PaymentToken;
(function (PaymentToken) {
    PaymentToken["ETH"] = "eth";
    PaymentToken["USDC"] = "usdc";
    PaymentToken["USDT"] = "usdt";
})(PaymentToken || (PaymentToken = {}));
export var CryptoPotionQuality;
(function (CryptoPotionQuality) {
    CryptoPotionQuality["Minor"] = "minor";
    CryptoPotionQuality["Standard"] = "standard";
    CryptoPotionQuality["Greater"] = "greater";
    CryptoPotionQuality["Superior"] = "superior"; // 5% chance - heals 60%
})(CryptoPotionQuality || (CryptoPotionQuality = {}));
//# sourceMappingURL=types.js.map